import React from 'react';
import { Pressable, StyleSheet, View, ViewStyle } from 'react-native';
import { C, R, SP } from '../../theme/tokens';

type CalcCardProps = {
  children: React.ReactNode;
  onPress?: () => void;
  style?: ViewStyle | ViewStyle[];
  /** When true, renders the orange 3px left stripe (used for featured cards). */
  accentStripe?: boolean;
};

const styles = StyleSheet.create({
  card: {
    borderRadius: R.card,
    borderWidth: 1,
    borderColor: C.edge,
    backgroundColor: C.panel,
    marginBottom: SP.sm + 4,
    overflow: 'hidden',
  },
  stripe: {
    borderLeftWidth: R.stripe,
    borderLeftColor: C.accent,
  },
  pressable: { borderRadius: R.card },
  cardContent: { padding: SP.md },
});

export const calcCardStyles = styles;

export function CalcCard({ children, onPress, style, accentStripe }: CalcCardProps) {
  const cardContent = (
    <View style={[styles.card, accentStripe && styles.stripe, style]}>
      <View style={styles.cardContent}>{children}</View>
    </View>
  );

  if (onPress) {
    return (
      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        style={({ pressed }) => [styles.pressable, { opacity: pressed ? 0.85 : 1 }]}
      >
        {cardContent}
      </Pressable>
    );
  }
  return cardContent;
}
